
export const  endpointsContactPresentation ={

    ACCESS_TO_PRESENTATION_OF_A_CONTACT: (idContactPresentation) => (
        `api/PresentationForContacts/accesToPresentatino/${idContactPresentation}`),

    GET_INFO_PROFILE_CONTACT_HOSPITAL_PRESENTATION: (idContactPresentation) => (
        `api/PresentationForContacts/infoContactPresentation/${idContactPresentation}`
    ),
    GET_PRODUCTS_CONTACT_PRESENTATION: (idContactPresentation) =>(
        `api/PresentationForContacts/getProductsContactPresentation/${idContactPresentation}`
    ),

}
 